<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2025-02-13 17:31:15
 * @FilePath: /wemeet-admin-new/src/views/marketing/pointsManage.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <div>
    <vab-query-form>
      <vab-query-form-left-panel :span="12">
        <el-button plain type="info" @click="goBack">返回</el-button>
      </vab-query-form-left-panel>

      <vab-query-form-right-panel :span="12">
        <el-button type="primary" @click="handleSend()">添加</el-button>
        <el-button type="primary" @click="handleAddType()">类型管理</el-button>
        <el-button type="primary" @click="donwLoadQrcode()">下载积分消费码</el-button>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="活动任务名称" prop="taskName" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.taskName ? row.taskName : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="活动类型" prop="taskTypeName" show-overflow-tooltip />
      <el-table-column label="备注" prop="remark" show-overflow-tooltip />
      <el-table-column label="积分规则" prop="ruleKey" show-overflow-tooltip>
        <template #default="{ row }">
          {{
            row.ruleKey == 'DIRECT_ACCESS'
              ? '扫码直接获取积分(每日一次)'
              : row.ruleKey == 'NEED_TWICE_SCAN'
              ? '同一个码扫码两次获得积分(两次需间隔20分钟)'
              : '扫码直接获取积分(不限制次数)'
          }}
        </template>
      </el-table-column>
      <el-table-column label="扫码获取积分数量" prop="points" show-overflow-tooltip />
      <el-table-column label="可获取积分总人数" prop="totalQuota" show-overflow-tooltip />
      <el-table-column label="可获取积分剩余人数" prop="remainingQuota" show-overflow-tooltip />

      <el-table-column label="操作" show-overflow-tooltip width="420">
        <template #default="{ row }">
          <el-button plain type="info" @click="handleSend(row)">编辑</el-button>
          <el-button plain type="primary" @click="handlePersonNum(row)">设置限制人数</el-button>
          <el-button plain type="success" @click="seeDetail(row)">绑定手机号</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-empty class="vab-data-empty" description="暂无任务" />
      </template>
    </el-table>

    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <addPoints
      ref="addLotteryRef"
      :meeting-code="queryForm.meetingCode"
      :meeting-type="queryForm.meetingType"
      @fetch-data="queryData"
    />
    <addPointsPerson
      ref="addPointsPersonRef"
      :meeting-code="queryForm.meetingCode"
      :meeting-type="queryForm.meetingType"
      @fetch-data="queryData"
    />
    <addPointsType
      ref="addPointsTypeRef"
      :meeting-code="queryForm.meetingCode"
      :meeting-type="queryForm.meetingType"
      @fetch-data="queryData"
    />
    <addPointsManager
      ref="lotteryListRef"
      :meeting-code="queryForm.meetingCode"
      :meeting-type="queryForm.meetingType"
    />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { useRoute } from 'vue-router'
  import { getActivityList, delPrizes, getRedeemPointsQrCode } from '@/api/exhibitionManage'
  import addPoints from './components/addPoints.vue'
  import addPointsPerson from './components/addPointsPerson.vue'
  import addPointsManager from './components/addPointsManager.vue'
  import addPointsType from './components/addPointsType.vue'
  import { getUserByPhone } from '@/api/user'
  export default defineComponent({
    name: 'PointsManage',
    components: {
      addPoints,
      addPointsManager,
      addPointsPerson,
      addPointsType,
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          pageSize: 10,
          pageNum: 1,
        },
        activeName: 'first',
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        addgroupDrawer: null,
        chooseVal: [],
        importRef: null,
        addLotteryRef: null,
        lotteryListRef: null,
        addPointsTypeRef: null,
        addPointsPersonRef: null,
        total: 0,
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            await delPrizes(row.id, state.queryForm.meetingCode)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        try {
          const { data } = await getActivityList(state.queryForm)
          state.list = data.list
          state.total = data.total
        } catch (e) {
          state.listLoading = false
          state.list = []
        }
        state.listLoading = false
      }

      onMounted(() => {
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.meetingType = route.query.type || 'EXHIBITION'
        fetchData()
      })

      const handleSend = (row) => {
        state.addLotteryRef.handleOpen(row)
      }

      const goBack = () => {
        proxy.$router.go(-1)
      }
      const seeDetail = (row) => {
        state.lotteryListRef.handleOpen(row)
      }
      const handlePersonNum = (row) => {
        state.addPointsPersonRef.handleOpen(row)
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const handleAddType = () => {
        state.addPointsTypeRef.handleOpen()
      }

      const donwLoadQrcode = async () => {
        const { data } = await getRedeemPointsQrCode({
          meetingCode: state.queryForm.meetingCode,
        })
        const link = document.createElement('a')
        link.href = data.qrcodeBase64
        link.download = '积分消费码.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }

      return {
        ...toRefs(state),
        handleEdit,
        handlePersonNum,
        queryData,
        fetchData,
        handleDelete,
        handleConfig,
        Delete,
        Search,
        Plus,
        handleSend,
        goBack,
        seeDetail,
        handleSizeChange,
        handleCurrentChange,
        handleAddType,
        donwLoadQrcode,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
